import { createSlice, current } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils

// ----------------------------------------------------------------------

type InitialState = {
  selectedDate: Date;
  selectedLocation: String;
  selectedStatus: Number;
};
const initialState: InitialState = {
  selectedDate: new Date(),
  selectedLocation: '',
  selectedStatus: 0
};

const slice = createSlice({
  name: 'date',
  initialState,
  reducers: {
    // START LOADING

    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    setSelectedLocation(state, action) {
      state.selectedLocation = action.payload;
    },
    setSelectedStatus(state, action) {
      state.selectedStatus = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const { actions } = slice;

// ----------------------------------------------------------------------

export function setUpdatedSelectedDate(date: any) {
  return async () => {
    dispatch(slice.actions.setSelectedDate(date));
  };
}
export function setUpdatedSelectedLocation(location: any) {
  return async () => {
    dispatch(slice.actions.setSelectedLocation(location));
  };
}
export function setUpdatedSelectedStatus(status: any) {
  return async () => {
    dispatch(slice.actions.setSelectedStatus(status));
  };
}

// ----------------------------------------------------------------------
